var _defs, _g, _circle, _circle2, _circle3, _circle4, _circle5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 192 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "logoClip"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    rx: 10,
    ry: 10
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#logoClip)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 96,
    fill: "#4F010F"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 96,
    width: 192,
    height: 96,
    fill: "#CE6F00"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 148,
    r: 7,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 148,
    r: 7,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 148,
    r: 7,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 170,
    r: 7,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 109,
    cy: 170,
    r: 7,
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.38126e9f33ec646b6a25b0230ade121a.svg";
export { ForwardRef as ReactComponent };